import { FirebaseData } from "../../General/FirebaseData";
import { SupportedLanguages } from "../../../../libs/i18next/language";
import { CustomFieldDataType } from "./CustomFieldDataType";
import { TranslationData } from "../../General/TranslationData";
import { PropertyData } from "../../Property/PropertyData";
import { LocalData } from "../../General/LocalData";
import { CustomFieldDataOptions } from "../../Property/Collections/PropertyCustomFieldData";
import { CustomFieldDataTypeHelper } from "./CustomFieldDataTypeHelper/CustomFieldDataTypeHelper";
import { PopupTemplates } from "../../../../components/deprecated/PopupTemplates/PopupTemplates";
import { ToastUtilities } from "../../../../libs/react-toastify/ToastUtilities";
import { CompanyCollectionData } from "./CompanyCollectionData";
import { Utilities } from "../../../../utils/utilities";
import { t } from "i18next";

export type CustomFieldGroup = "component" | "tag";
export const SupportedCustomFieldGroup: CustomFieldGroup[] = ["component", "tag"];

export type CustomFieldRequiredFieldValuesToDisplay = {
  [fieldID: string]: any[];
};

export class CompanyCustomFieldData extends FirebaseData {
  dataType: CustomFieldDataTypeHelper<any> = CustomFieldDataType.TEXT;
  dataOptions: CustomFieldDataOptions = {};

  standardLangCode: SupportedLanguages = SupportedLanguages.EN;
  name: TranslationData = new TranslationData();

  deprecated: boolean = false;
  isReference: boolean = false;
  allProperties: boolean = false;
  selectedProperties: PropertyData[] = [];

  requiredFieldValuesToDisplay: CustomFieldRequiredFieldValuesToDisplay = {};

  setup(data: any) {
    this.dataType = CustomFieldDataType.getTypeWithId(data.dataType);
    this.dataOptions = {};
    if (typeof data.dataOptions === "object") {
      this.dataOptions = {
        timeEnabled: typeof data.dataOptions.timeEnabled === "boolean" ? data.dataOptions.timeEnabled : undefined,
        dateEnabled: typeof data.dataOptions.dateEnabled === "boolean" ? data.dataOptions.dateEnabled : undefined,
        contractorAccess: typeof data.dataOptions.contractorAccess === "boolean" ? data.dataOptions.contractorAccess : undefined,
        formula: typeof data.dataOptions.formula === "string" ? data.dataOptions.formula : undefined,
        collectionID: typeof data.dataOptions.collectionID === "string" ? data.dataOptions.collectionID : undefined,
        standardID: typeof data.dataOptions.standardID === "string" ? data.dataOptions.standardID : undefined,
        previewFiles: typeof data.dataOptions.previewFiles === "boolean" ? data.dataOptions.previewFiles : undefined,
        customDataTypeID: typeof data.dataOptions.customDataTypeID === "string" ? data.dataOptions.customDataTypeID : undefined,
        isMulti: typeof data.dataOptions.isMulti === "boolean" ? data.dataOptions.isMulti : undefined,
        hideParentReference: typeof data.dataOptions.hideParentReference === "boolean" ? data.dataOptions.hideParentReference : undefined,
      };
    }

    this.requiredFieldValuesToDisplay = typeof data.requiredFieldValuesToDisplay === "object" ? data.requiredFieldValuesToDisplay : {};

    this.standardLangCode = SupportedLanguages.getLanguageWithCode(data.standardLangCode);
    this.name.setup(data.name, this.standardLangCode);

    this.deprecated = typeof data.deprecated === "boolean" ? data.deprecated : false;
    this.isReference = typeof data.isReference === "boolean" ? data.isReference : false;

    this.allProperties = typeof data.allProperties === "boolean" ? data.allProperties : false;
    this.selectedProperties = Array.isArray(data.selectedProperties)
      ? (data.selectedProperties as any[]).filter((el) => typeof el === "string").map((id) => LocalData.properties.addData(id))
      : [];

    super.setup(data);
  }

  deleteCustomField(onFinish: () => void) {
    const collection = this.parent;
    if (collection instanceof CompanyCollectionData) {
      PopupTemplates.presentVerifyDelete(this.name.translate(), () => {
        ToastUtilities.presentPromise(
          t("main.deleting") + " " + this.name.translate(),
          collection.customFields.deleteDocument(this.id).then(() => {
            onFinish();
          })
        );
      });
    }
  }

  static handleSave(field: CompanyCustomFieldData | undefined, collection: CompanyCollectionData, saveData: { [key: string]: any }) {
    saveData["readAccess"] = Utilities.convertReadAccess(collection.readAccess);

    if (field) {
      ToastUtilities.presentSavingToast(field?.saveUpdate(saveData));
    } else {
      ToastUtilities.presentSavingToast(
        collection.customFields.createData({
          allProperties: true,
          ...saveData,
        })
      );
    }
  }
}

